import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

type PdfMakeWithVfs = typeof pdfMake & {
  vfs: Record<string, string>;
};

const pdfMakeTyped = pdfMake as PdfMakeWithVfs;

pdfMakeTyped.vfs = (pdfFonts as any).pdfMake?.vfs;

export default pdfMakeTyped;

export interface PlRow {
  categoryName: string;
  totalIncome?: number;
  totalExpenditure?: number;
}

export interface PlPreview {
  periodFrom: string;
  periodTo: string;
  totalIncome: number;
  totalExpenditure: number;
  netProfit: number;
  grossProfitMargin: string;
  income: PlRow[];
  expenditure: PlRow[];
}
